import React, {FC} from 'react';
import {ServicesList} from "./list/ServicesList";
import {Divider, makeStyles} from "@material-ui/core";
import {CreateServiceDialogForm} from "./form/CreateServiceDialogForm";

const useStyles = makeStyles(theme => ({
    actionsBar: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        paddingBottom: theme.spacing(4)
    }
}))

export const ServicesScreen: FC = () => {
    const classes = useStyles();
    return (
        <div>
            <div className={classes.actionsBar}>
                <CreateServiceDialogForm/>
            </div>
            <Divider style={{marginBottom: 16}}/>
            <ServicesList/>
        </div>
    )
}
